import { render, staticRenderFns } from "./AdminNotificationPage.vue?vue&type=template&id=b3463138&scoped=true"
import script from "./AdminNotificationPage.vue?vue&type=script&lang=js"
export * from "./AdminNotificationPage.vue?vue&type=script&lang=js"
import style0 from "./AdminNotificationPage.vue?vue&type=style&index=0&id=b3463138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3463138",
  null
  
)

export default component.exports